import { useState } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import TrustSection from "@/components/TrustSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

const LandingPage = () => {
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Header onQuoteClick={() => setIsQuoteOpen(true)} />
      <main>
        <HeroSection onQuoteClick={() => setIsQuoteOpen(true)} />
        <ServicesSection />
        <TrustSection />
        <ContactSection isOpen={isQuoteOpen} onClose={() => setIsQuoteOpen(false)} />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
